import React from "react";
import BOOM_PDF from "../utils/BOOM_Preview.pdf";

import Button from "@mui/material/Button";

import BOOM_COPERTINA_600 from "../images/HomePage/BOOM_COPERTINA_600.jpg";
import Extra1_600 from "../images/HomePage/Extra1_600.jpg";

import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import DownloadIcon from "@mui/icons-material/Download";

const HomePage = () => {
  return (
    <>
      <div className="home-page">
        <div className="photo-left">
          <img src={Extra1_600} alt="Description 1" />
        </div>
        <div className="photo-center">
          <img src={BOOM_COPERTINA_600} alt="Description 2" />
        </div>
        <div className="description">
          <p style={{ fontWeight: "bold", fontSize: "28px" }}>
            Milly Fanzaga disponibile per lezioni tecnico teoriche sulla storia
            della batteria.
          </p>
          <p style={{ fontSize: "20px", marginTop: "2px" }}>
            Un percorso che parte dalla nascita dei primi rudimenti, fino ad
            arrivare alle ritmiche moderne, attraverso la conoscenza di tutti i
            generi musicali che hanno caratterizzato il percorso storico di
            questo strumento.
          </p>
          <p
            style={{ fontWeight: "bold", fontSize: "20px", marginTop: "15px" }}
          >
            L’unico corso veramente completo!
            <br /> Con supporto audio video.
          </p>
          {/* <div>
            <p style={{ fontSize: "20px", marginTop: "15px" }}>
              info@millyfanzaga.com
            </p>
            <p style={{ fontSize: "20px" }}>Tel. +39 393 26 89 311</p>
            <a
              href={"https://www.instagram.com/fanzagam/"}
              style={{ textDecoration: "none" }}
            >
              <p
                style={{
                  fontSize: "20px",
                  marginTop: "10px",
                  color: "#dd2a7b",
                }}
              >
                <InstagramIcon
                  style={{ verticalAlign: "middle", marginRight: "2px" }}
                />{" "}
                fanzagam
              </p>
            </a>
            <a
              href={"https://www.facebook.com/milly.fanzaga"}
              style={{ textDecoration: "none" }}
            >
              <p style={{ fontSize: "20px", color: "#4676ee" }}>
                <FacebookIcon
                  style={{ verticalAlign: "middle", marginRight: "2px" }}
                />{" "}
                Milly Fanzaga
              </p>
            </a>
          </div> */}
          <div style={{ marginTop: "35px" }}>
            <Button
              href={BOOM_PDF}
              download="BOOM Milly Fanzaga - Preview.pdf"
              variant="contained"
              startIcon={<DownloadIcon />}
            >
              SFOGLIA IL LIBRO PER UNA DEMO!
            </Button>
          </div>
          <div>
            <p
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                marginTop: "35px",
              }}
            >
              Scrivimi per ordinare il Libro!
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
